"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TextTruncate = function TextTruncate(props) {
  var textProp = props.text === true || props.text === false ? props.text.toString() : props.text;
  var biggerThenLimit = textProp !== null && textProp.length > props.limit;
  var text = biggerThenLimit && props.limit !== -1 ? textProp.substring(0, props.limit) : textProp;
  if (biggerThenLimit) {
    switch (props.type) {
      case "dotted":
        text += "...";
        break;
      default:
        break;
    }
  }
  var config = {
    "truncated": true,
    "active": biggerThenLimit
  };
  config[props.type] = true;
  var classes = (0, _classnames["default"])(config);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: classes
  }, text);
};
TextTruncate.propTypes = {
  text: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  limit: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(['dotted', 'gradient'])
};
TextTruncate.defaultProps = {
  type: 'dotted',
  limit: -1
};
var _default = exports["default"] = TextTruncate;